// extracted by mini-css-extract-plugin
module.exports = {"logo":"CarevincoLogo_logo__DLx7J","header":"CarevincoLogo_header__X0jai"};